module.exports = __webpack_public_path__ + "static/media/frontCoverImage.e622352b.webp";